import Card from "components/common/Card";
import Button from "components/semantic/Button";
import Input from "components/semantic/Input";
import Select from "components/semantic/Select";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPolicyDetailThunk, putPolicyData } from "store/thunk/kyp.thunk";
import { useAppDispatch, useAppSelector } from "utils/hooks";

const LifePreview = () => {
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const navigate = useNavigate();

  const policyData = useAppSelector((state) => state.rootReducer.kypSlice.doceyeOutputData);
  const isLoading = useAppSelector((state) => state.rootReducer.kypSlice.loadingPutPolicy);

  useEffect(() => {
    dispatch(getPolicyDetailThunk(params?.policyId));
  }, []);

  const { values, handleSubmit, setFieldValue }: any = useFormik({
    initialValues: {
      insuranceCompanyId: policyData?.insuranceCompany?.name,
      policyName: policyData?.policyName,
      policyNumber: policyData.policyNumber,
      premiumAmount: policyData.premiumAmount,
      sumInsured: policyData.sumInsured,
      modeOfPayment: policyData?.modeOfPayment,
      typeOfPlan: policyData?.typeOfPlan,
      premiumPaymentOption: policyData?.premiumPaymentOption,
      finalPremiumDueDate: policyData?.finalPremiumDueDate,
      maturityAmount: policyData?.maturityAmount,
      deathCover: policyData?.deathCover,
      moneyBack: policyData?.moneyBack,
      illustrationReading: policyData?.illustrationReading,
      freeLookPeriod: policyData?.freeLookPeriod,
      surrenderValue: policyData?.surrenderValue,
      lifeProductExplanation: policyData?.lifeProductExplanation,
      ulipFundName: policyData?.ulipFundName,
      riderName: policyData?.riderName,
      existingPoliciesDetail: policyData?.existingPoliciesDetail
    },
    enableReinitialize: true,
    onSubmit: async (value: any) => {
      const payload = { ...value };
      payload.insuranceCompanyId = policyData.insuranceCompany._id;
      payload.policyTypeId = policyData.policyTypeId;
      dispatch(putPolicyData({ policyId: params?.policyId, body: payload }))
        .unwrap()
        .then((data) => {
          if (data?.success) navigate(`/kyp/questionare/${params?.policyId}`);
        });
    }
  });

  const inputProps = { disabled: true, parentClassName: "w-full", className: "bg-[#F7F7F7]" };

  return (
    <>
      <h1 className="text-xl sm:text-2xl font-extrabold mb-4 sm:mb-6 ">Insurance Policy Details</h1>
      <Card className=" w-full space-y-3 md:space-y-4" parentClassName="w-full">
        <div className="flex flex-col md:flex-row gap-x-5 w-full px-5 md:px-10 pt-5 md:pt-10 gap-y-3">
          <Input value={values?.insuranceCompanyId || "-"} label="Insurance Company" {...inputProps} />
          <Input value={values?.policyName || "-"} label="Plan Name" {...inputProps} />
        </div>
        <div className="flex flex-col md:flex-row gap-x-5 w-full px-5 md:px-10 pb-5 md:pb-10 gap-y-3">
          <Input value={values?.policyNumber || "-"} label="Policy Number" {...inputProps} />
          <Input value={values?.premiumAmount || "-"} label="Premium Amount" {...inputProps} />
          <Input value={values?.sumInsured || "-"} label="Sum Assured" {...inputProps} />
          {policyData?.modeOfPayment ? (
            <Input value={values?.modeOfPayment || "-"} label="Premium Payment Frequency" {...inputProps} />
          ) : (
            <Select
              value={values?.modeOfPayment}
              label="Premium Payment Frequency"
              parentClassName="w-full"
              className="bg-[#F7F7F7]"
              disabled={policyData?.modeOfPayment}
              onChange={(e) => setFieldValue("modeOfPayment", e.target.value)}
              options={[
                { label: "Monthly", value: "Monthly" },
                { label: "Quarterly", value: "Quarterly" },
                { label: "Half-yearly", value: "Half-yearly" },
                { label: "Annual", value: "Annual" }
              ]}
            />
          )}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full px-5 md:px-10 pb-5 md:pb-10">
          {values?.lifeProductExplanation && <Input value={values?.lifeProductExplanation} label="Life Product Explanation" {...inputProps} parentClassName="col-span-1 md:col-span-2" />}
          {values?.typeOfPlan && <Input value={values?.typeOfPlan} label="Plan Type" {...inputProps} />}
          {values?.premiumPaymentOption && <Input value={values?.premiumPaymentOption} label="Premium Payment Option" {...inputProps} />}
          {values?.finalPremiumDueDate && <Input value={values?.finalPremiumDueDate} label="Final Premium Due Date" {...inputProps} />}
          {values?.maturityAmount && <Input value={values?.maturityAmount} label="Maturity Amount" {...inputProps} />}
          {values?.deathCover && <Input value={values?.deathCover} label="Death Cover" {...inputProps} />}
          {values?.moneyBack && <Input value={values?.moneyBack} label="Money Back" {...inputProps} />}
          {values?.illustrationReading && <Input value={values?.illustrationReading} label="Illustration of Benefits" {...inputProps} />}
          {values?.freeLookPeriod && <Input value={values?.freeLookPeriod} label="Freelook Period" {...inputProps} />}
          {values?.surrenderValue && <Input value={values?.surrenderValue} label="Surrender Value" {...inputProps} />}
          {values?.ulipFundName && <Input value={values?.ulipFundName} label="ULIP Fund Name" {...inputProps} />}
          {values?.riderName && <Input value={values?.riderName} label="Rider Name" {...inputProps} />}
          {values?.existingPoliciesDetail && <Input value={values?.existingPoliciesDetail} label="Existing Policies Detail" {...inputProps} />}
        </div>
        <div className="flex justify-center items-center py-5 border-t-[1px] border-border-color mt-10">
          <Button title="NEXT" onClick={handleSubmit} isLoading={isLoading} />
        </div>
      </Card>
    </>
  );
};

export default LifePreview;
